import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import UpcomingTopups from './UpcomingTopups';
import { getUpcomingTopupsInitiate } from '../../../actions/company';
import { currentFlowTypeEnum } from '../../common/components/constants';

const mapStateToProps = state => {
  const upcomingTopupsData = _get(state, 'company.upcomingTopupsData', []);
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    viewOnlyMode,
    selectedWorkspace,
    upcomingTopupsData,
    fetchingUpcomingTopups:
      _get(state, 'apiState.GET_UPCOMING_TOPUPS.isFetching', true) &&
      !_get(state, 'apiState.GET_UPCOMING_TOPUPS.isIdle', false),
    fetchedUpcomingTopups: _get(
      state,
      'apiState.GET_UPCOMING_TOPUPS.success',
      true,
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getUpcomingTopups: payload => dispatch(getUpcomingTopupsInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpcomingTopups);
